import React from 'react'
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/chatbotWhatsAppIntegrationSetup.module.scss"
import { Grid, Typography } from '@mui/material'
import { instagramPrereq } from '../../../../utils/content'

interface launchWhatsApp {
    launch: any,
    viewIntegration?: boolean
}


const ChatbotInstagramIntegrationSetup = (props: launchWhatsApp) => {

    return (
        <>
            <>
                <Grid item>
                    <Grid container gap={2}>
                        <Grid item style={{ width: "100%" }}>
                            <Typography component='span' className={styles.setUpValue}>A few things that are necessary to integrate with Instagram should be ready before you begin. We have compiled a collection of helpful hints that will walk you through each stage.</Typography>
                        </Grid>
                        <Grid item style={{ width: "100%" }}>
                            <Typography component='span' className={styles.setUpTitle}>Steps to integrate</Typography>
                        </Grid>
                        <Grid item>
                            {instagramPrereq.map((ele, index) => {
                                return (
                                    <Grid container key={index} gap={2} alignItems={"start"} style={{ marginBottom: "15px" }} flexWrap={"nowrap"}>
                                        <Grid item className={styles.setUpIndexGrid}>
                                            <Typography component='span' className={styles.setUpIndex}>{index + 1}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Grid container direction={"column"} gap={"5px"}>
                                                <Grid item>
                                                    <Typography component='span' className={styles.setUpValue}>{ele.title}</Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Typography component='span' className={styles.setUpContent}>{ele.content}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                        </Grid>

                    </Grid>
                </Grid>
            </>
        </>
    )
}

export default ChatbotInstagramIntegrationSetup